module.exports = __webpack_public_path__ + "assets/yumi.0f922eec.svg";